import { FC } from 'react'
import { PaymentMethods } from './components/PaymentMethods/PaymentMethods'
import { FooterColumn } from './components/FooterColumn/FooterColumn'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { Text } from '@blueprintjs/core'
import { Link } from '@inertiajs/react'
import { LangSelector } from './components/LangSelector/LangSelector'
import { CartDrawer } from 'client/components/CartDrawer/CartDrawer'

type TProps = {}

const Footer: FC<TProps> = ({}) => {
  const { t } = useTranslation(ClientLocaleNS.Common)
  return (
    <footer className="flex flex-col justify-center w-full gap-20 py-20">
      <ResponsiveBlock>
        <div className="grid grid-cols-3 w-full gap-20">
          <FooterColumn i18key="footer.titles.1">
            <Text tagName="span" className="text-palette-grey--50 font-body---16px whitespace-pre-wrap leading-6">
              {t('footer.address')}
            </Text>
            <LangSelector />
          </FooterColumn>
          <FooterColumn i18key="footer.titles.2" className="justify-center">
            <Link href="/about_us">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.about')}
              </Text>
            </Link>
            <Link href="/terms">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.terms')}
              </Text>
            </Link>
            <Link href="/refund">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.refund')}
              </Text>
            </Link>
          </FooterColumn>
          <FooterColumn i18key="footer.titles.3" className="justify-end">
            <div className="flex flex-col mb-10">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.support_email')}
              </Text>
            </div>
            <div className="flex w-full">
              <PaymentMethods />
            </div>
          </FooterColumn>
        </div>
      </ResponsiveBlock>
      <CartDrawer />
    </footer>
  )
}

export { Footer }
